import React from 'react';
import { FlameIcon } from 'lucide-react';
export function ScarcityBar({
  spotsLeft = 9,
  total = 100
}: {
  spotsLeft?: number;
  total?: number;
}) {
  const taken = total - spotsLeft;
  const percent = Math.round(taken / total * 100);
  return <div className="w-full max-w-md rounded-2xl border border-red-200 bg-red-50 p-4" data-id="element-195" data-mp="2l4o1p39evveh">
      <p className="flex items-center justify-center gap-1.5 text-center text-[13px] font-extrabold uppercase tracking-wide text-red-600 sm:text-sm" data-id="element-196" data-mp="2q2g44r7omzwx">
        <FlameIcon className="h-4 w-4" aria-hidden="true" data-id="element-197" data-mp="2g5l7kduyz9la" />
        Solo quedan {spotsLeft} cupos al precio promocional
      </p>
      <div className="mt-3 h-3.5 w-full overflow-hidden rounded-full bg-red-100" role="progressbar" aria-valuenow={percent} aria-valuemin={0} aria-valuemax={100} aria-label={`${percent}% de los cupos promocionales ya fueron tomados`} data-id="element-198" data-mp="2273o4sc3kj96">
        <div className="h-full rounded-full bg-red-500 transition-all duration-700" style={{
        width: `${percent}%`
      }} data-id="element-199" data-mp="5e1veknwcxyi" />
      </div>
      <p className="mt-2 text-center text-[11px] font-semibold text-red-500/90" data-id="element-200" data-mp="33kig1h6xzqgj">
        {percent}% de los cupos ya fueron tomados · {taken} de {total} vendidos
      </p>
    </div>;
}